import React, { Component } from "react";
import $ from "jquery";

export default class OptSearch2 extends Component {
  constructor(props) {
    super(props);
    let data = { ...props.data };
    this.state = {
      dynamicId: "",
    };
  }

  submitOptForm = (needReload = false) => {
    let match = "{";
    var inputText = $("#search-text").val();
    const OptSearchUrl = window.location.pathname;
    let params = {};
    $("p.selected").text(inputText);
    $("p.selected").attr("data-value", inputText);
    let searchValue =
      $("td.search-row-text").find("p.selected").data("value") || "";
    if (searchValue) {
      params["search"] = searchValue;
    }
    $(".search-row")
      .not(".search-row-text")
      .each(function () {
        var title = $(this).children(".search-form__td-title").attr("value");
        var selectedLi = $(this).find("li.selected");
        var value = selectedLi.length ? selectedLi.attr("value") : null;

        if (title && value) {
          params[title] = value;
          match += `"${title}":"${value}", `;
          sessionStorage.setItem(title, value);
          if (title === "id_category") {
            //console.log("Source filter applied: " + value);
          }
        }
      });
    let queryString = Object.keys(params)
      .map((key) => `${key}=${encodeURIComponent(params[key])}`)
      .join("&");
    let newUrl = `${OptSearchUrl}?${queryString}`;
    window.history.pushState(null, "", newUrl);
    if (needReload) {
      //console.log("Reloading page with new parameters.");
      window.location.reload();
    }
  };

  updateValue() {
    const value = document.getElementById("search-text").value;
    document.querySelector(".select-container p").innerText = value;
  }

  startType = (e) => {
    if (e.target.value !== "") {
      this.setState({
        dynamicId: "opusdata",
      });
    } else {
      this.setState({
        dynamicId: "",
      });
    }
  };

  clear = () => {
    sessionStorage.clear();
    window.location.reload();
  };

  componentDidMount() {
    const currentPath = window.location.pathname;
    const urlParams = new URLSearchParams(window.location.search);

    sessionStorage.setItem("OptSearchUrl", currentPath);

    const text = String(urlParams.get("search"));
    const composition = String(urlParams.get("id_composition"));
    const source = String(urlParams.get("id_category"));
    const place = String(urlParams.get("id_place_of_storage"));
    const opus = String(urlParams.get("id_opus"));
    const tonation = String(urlParams.get("id_tonation"));
    const genere = String(urlParams.get("id_genere"));

    let setReload = true;
    let optSearchObj = {};

    if (text) {
      sessionStorage.setItem("search", text);
      optSearchObj["search"] = text;
    }
    if (composition) {
      sessionStorage.setItem("id_composition", composition);
      optSearchObj["id_composition"] = composition;
    }
    if (source) {
      sessionStorage.setItem("id_category", source);
      optSearchObj["id_category"] = source;
    }
    if (place) {
      sessionStorage.setItem("id_place_of_storage", place);
      optSearchObj["id_place_of_storage"] = place;
    }
    if (opus) {
      sessionStorage.setItem("id_opus", opus);
      optSearchObj["id_opus"] = opus;
    }
    if (tonation) {
      sessionStorage.setItem("id_tonation", tonation);
      optSearchObj["id_tonation"] = tonation;
    }
    if (genere) {
      sessionStorage.setItem("id_genere", genere);
      optSearchObj["id_genere"] = genere;
    }

    sessionStorage.setItem("OptSearch2", JSON.stringify(optSearchObj));

    this.loadFiltersFromSessionStorage();

    if (!sessionStorage.getItem("submitFormCalled") && setReload) {
      this.submitOptForm();
      sessionStorage.setItem("submitFormCalled", "true");
    } else {
      const storedcomposition = sessionStorage.getItem("id_composition");
      const storedsource = sessionStorage.getItem("id_category");
      const storedplace = sessionStorage.getItem("id_place_of_storage");
      const storedOpus = sessionStorage.getItem("id_opus");
      const storedTonation = sessionStorage.getItem("id_tonation");
      const storedGenere = sessionStorage.getItem("id_genere");

      if (
        composition === storedcomposition &&
        source === storedsource &&
        place === storedplace &&
        opus === storedOpus &&
        tonation === storedTonation &&
        genere === storedGenere
      ) {
        setReload = false;
        sessionStorage.removeItem("submitFormCalled");
        //console.log('Filtry są takie same, nie wymagają przeładowania.');
      }
    }
  }

  loadFiltersFromSessionStorage() {
    let text = sessionStorage.getItem("search");
    let composition = sessionStorage.getItem("id_composition");
    let source = sessionStorage.getItem("id_category");
    let place = sessionStorage.getItem("id_place_of_storage");
    let opus = sessionStorage.getItem("id_opus");
    let tonation = sessionStorage.getItem("id_tonation");
    let genere = sessionStorage.getItem("id_genere");

    const urlParams = new URLSearchParams(window.location.search);
    const textUrl = urlParams.get("search");
    const compositionUrl = urlParams.get("id_composition");
    const sourceUrl = urlParams.get("id_category");
    const placeUrl = urlParams.get("id_place_of_storage");
    const opusUrl = urlParams.get("id_opus");
    const tonationUrl = urlParams.get("id_tonation");
    const genereUrl = urlParams.get("id_genere");

    if (text != null && text === textUrl) {
      $("#search-text").val(text);
      $("p.selected").text(text);
      $("p.selected").attr("data-value", text);
    }

    if (composition != null && composition === compositionUrl) {
      $("#composition li").removeClass("selected");
      $("#composition li").each(function () {
        if ($(this).attr("value") === composition) {
          $(this).addClass("selected");
        }
      });
    }

    if (source != null && source === sourceUrl) {
      $("#source li").removeClass("selected");
      $("#source li").each(function () {
        if ($(this).attr("value") === source) {
          $(this).addClass("selected");
        }
      });
    }

    if (place != null && place === placeUrl) {
      $("#place li").removeClass("selected");
      $("#place li").each(function () {
        if ($(this).attr("value") === place) {
          $(this).addClass("selected");
        }
      });
    }

    if (opus != null && opus === opusUrl) {
      $("#opus li").removeClass("selected");
      $("#opus li").each(function () {
        if ($(this).attr("value") === opus) {
          $(this).addClass("selected");
        }
      });
    }

    if (tonation != null && tonation === tonationUrl) {
      $("#tonation li").removeClass("selected");
      $("#tonation li").each(function () {
        if ($(this).attr("value") === tonation) {
          $(this).addClass("selected");
        }
      });
    }

    if (genere != null && genere === genereUrl) {
      $("#genere li").removeClass("selected");
      $("#genere li").each(function () {
        if ($(this).attr("value") === genere) {
          $(this).addClass("selected");
        }
      });
    }
  }

  render() {
    document.addEventListener("keypress", function (event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        document.getElementById("search-engine-submit").click();
      }
    });

    $(function () {
      $(".select-container ul")
        .unbind()
        .click(function () {
          $(this).toggleClass("opened");
        });

      $("#optional-search-form ul li").click(function () {
        var match = "{";
        var inputText = $("#search-text").val();
        $("p.selected").text(inputText);
        $("p.selected").attr("value", inputText);

        if ($(this).hasClass("selected")) {
          // Nie rób nic, jeśli element już jest zaznaczony
        } else {
          $(this).addClass("selected").siblings().removeClass("selected");

          const parentId = $(this).parent("ul").attr("id");
          const itemValue = $(this).attr("value");
          sessionStorage.setItem(`id_${parentId}`, itemValue);

          $(".search-row").each(function () {
            var title = $(this)
              .children(".search-form__td-title")
              .attr("value");
            var value = $(this).find(".selected").attr("value");
            match += '"' + title + '":';
            match += '"' + value + '", ';
          });
        }
        match = match.slice(0, -2);
        match += "}";
        sessionStorage.setItem("OptSearch2", match);
      });

      $("#search-text").on("input", function (e) {
        var inputText = $("#search-text").val();
        $("p.selected").text(inputText);
      });
    });

    $(document).mouseup(function (e) {
      var container = $(".select-container ul.opened");
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass("opened");
      }
    });

    // LABELS BASED ON LANGUAGE
    let search_label_1 =
      window.location.href.indexOf("/en/") > -1 ? "Clear" : "Wyczyść";
    let search_label_2 =
      window.location.href.indexOf("/en/") > -1
        ? "Enter a search phrase"
        : "Wpisz szukaną frazę";
    let search_label_3 =
      window.location.href.indexOf("/en/") > -1 ? "Search" : "Szukaj";
    let search_label_4 =
      window.location.href.indexOf("/en/") > -1 ? "all" : "wszystkie";
    let search_label_5 =
      window.location.href.indexOf("/en/") > -1 ? "enter..." : "wpisz...";

    return (
      <div className="optional-search-container OptSearch2">
        <form id="optional-search-form" className="OptSearch2">
          <table>
            <tbody>
              <tr className="search-row">
                <td
                  colSpan={2}
                  className="search-row-text search-form__td-title"
                  value="search"
                >
                  <input
                    id="search-text"
                    type="text"
                    placeholder={search_label_2}
                    aria-label={search_label_2}
                  />
                  <p className="selected" style={{ margin: 0 }}></p>
                </td>
              </tr>
              <tr>
                <td className="search-row">
                  <span
                    className="search-form__td-title"
                    value={this.props.filter_search[0].field_name}
                  >
                    {this.props.filter_search[0].name}
                  </span>
                  <div className="select-container">
                    <ul id="composition">
                      <li className="selected" value="">
                        {search_label_4}
                      </li>
                      {this.props.filter_search[0].list.map(function (
                        item,
                        index
                      ) {
                        var name = item.name;
                        var id = item.id;

                        return (
                          <li
                            key={index}
                            value={id}
                            dangerouslySetInnerHTML={{ __html: name }}
                          ></li>
                        );
                      })}
                    </ul>
                  </div>
                </td>
                <td className="search-row">
                  <span
                    className="search-form__td-title"
                    value={this.props.filter_search[1].field_name}
                  >
                    {this.props.filter_search[1].name}
                  </span>
                  <div className="select-container">
                    <ul id="source">
                      <li className="selected" value="">
                        {search_label_4}
                      </li>
                      {this.props.filter_search[1].list.map(function (
                        item,
                        index
                      ) {
                        var name = item.name;
                        var id = item.id;
                        return (
                          <li
                            key={index}
                            value={id}
                            dangerouslySetInnerHTML={{ __html: name }}
                          ></li>
                        );
                      })}
                    </ul>
                  </div>
                </td>
              </tr>
              <tr>
                <td className="search-row">
                  <span
                    className="search-form__td-title"
                    value={this.props.filter_search[3].field_name}
                  >
                    {this.props.filter_search[3].name}
                  </span>
                  <div className="select-container">
                    <ul id="opus">
                      <li className="selected" value="">
                        {search_label_4}
                      </li>
                      {this.props.filter_search[3].list.map(function (
                        item,
                        index
                      ) {
                        var name = item.name;
                        var id = item.id;
                        return (
                          <li
                            key={index}
                            value={id}
                            dangerouslySetInnerHTML={{ __html: name }}
                          ></li>
                        );
                      })}
                    </ul>
                  </div>
                </td>
                <td className="search-row">
                  <span
                    className="search-form__td-title"
                    value={this.props.filter_search[2].field_name}
                  >
                    {this.props.filter_search[2].name}
                  </span>
                  <div className="select-container">
                    <ul id="place">
                      <li className="selected" value="">
                        {search_label_4}
                      </li>
                      {this.props.filter_search[2].list.map(function (
                        item,
                        index
                      ) {
                        var name = item.name;
                        var id = item.id;
                        return (
                          <li
                            key={index}
                            value={id}
                            dangerouslySetInnerHTML={{ __html: name }}
                          ></li>
                        );
                      })}
                    </ul>
                  </div>
                </td>
                {/* <td><span className="search-form__td-title" value={this.props.filter_search[3].field_name}>{this.props.filter_search[3].name}</span>
									<div className="select-container">
										<input onChange={this.startType} id="opus" list="opusdata" type="text" placeholder={search_label_5} />
										<datalist id={this.state.dynamicId}>
											{this.props.filter_search[3].list.map(function (item, index) {
												return (
													<option key={index} value={item.id}>{item.name}</option>
												)
											})}
										</datalist>
									</div>
								</td> */}
              </tr>
              <tr>
                <td className="search-row">
                  <span
                    className="search-form__td-title"
                    value={this.props.filter_search[4].field_name}
                  >
                    {this.props.filter_search[4].name}
                  </span>
                  <div className="select-container">
                    <ul id="tonation">
                      <li className="selected" value="">
                        {search_label_4}
                      </li>
                      {this.props.filter_search[4].list.map(function (
                        item,
                        index
                      ) {
                        var name = item.name;
                        var id = item.id;
                        return (
                          <li
                            key={index}
                            value={id}
                            dangerouslySetInnerHTML={{ __html: name }}
                          ></li>
                        );
                      })}
                    </ul>
                  </div>
                </td>
                <td className="search-row">
                  <span
                    className="search-form__td-title"
                    value={this.props.filter_search[5].field_name}
                  >
                    {this.props.filter_search[5].name}
                  </span>
                  <div className="select-container">
                    <ul id="genere">
                      <li className="selected" value="">
                        {search_label_4}
                      </li>
                      {this.props.filter_search[5].list.map(function (
                        item,
                        index
                      ) {
                        var name = item.name;
                        var id = item.id;
                        return (
                          <li
                            key={index}
                            value={id}
                            dangerouslySetInnerHTML={{ __html: name }}
                          ></li>
                        );
                      })}
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <div className="search-engine-options">
            <button onClick={this.clear}>{search_label_1}</button>
            <button
              id="search-engine-submit"
              className="submit"
              onClick={(e) => {
                e.preventDefault();
                this.submitOptForm(true);
              }}
            >
              {search_label_3}
            </button>
          </div>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Elements/OptSearch2/OptSearch2.js